import { Component, PropsWithChildren } from 'react';

import { isSelfServiceError } from '../../helpers/Errors';
import { SupportedErrorTypes } from '../../services/ErrorService';
import { ErrorComponent } from './ErrorComponent';


type ErrorBoundaryState = {
  error: Error | null;
};

export class ReactLifeCycleErrorBoundary extends Component<PropsWithChildren, ErrorBoundaryState> {
  state: ErrorBoundaryState = { error: null };

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { error };
  }

  render() {
    const { error } = this.state;

    if (error) {
      const errorType = isSelfServiceError(error) ? error.reason : SupportedErrorTypes.unexpectedError;

      return <ErrorComponent errorType={errorType} />;
    }

    return this.props.children as React.ReactElement;
  }
}
